<template>
  <div id="app" :class="isLangEn ? 'app-layout-type-en' : ''">
    <router-view />
    <GlobalLayer />
  </div>
</template>

<script>
import GlobalLayer from '@/components/globalLayer'

import { mapMutations, mapState } from 'vuex'
// import home from './locales/lang/zh-CN/home'

import utils from '@/utils'

export default {
  name: 'app',
  components: {
    GlobalLayer
  },
  methods: {
    ...mapMutations({
      setMoblie: 'CHECK_MOBILE'
    }),
    checkMobile () {
      const ua = navigator.userAgent.toLowerCase()
      return (/iphone|android|ucweb|ucbrowser|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(ua) && !/ipad/i.test(ua)) || document.body.clientWidth <= 768
    },
    // // 微信分享
    // initWxConfig () {
    //   let data = this.data['微信分享']
    //   const ua = window.navigator.userAgent
    //   if (!ua.match(/MicroMessenger/i)) return
    //   let url = window.location.href
    //   axios.get(`https://misc.geekbang.org/wxmisc/wxshare/sign?url=${encodeURIComponent(url)}&mpid=gh_a4dbefba05a2`)
    //   .then(res => {
    //     if (res.data.code === 0) {
    //       if (!window.wx) return
    //       window.wx.config({
    //         debug: false,
    //         appId: res.data.data.appId,
    //         timestamp: res.data.data.timestamp,
    //         nonceStr: res.data.data.nonceStr,
    //         signature: res.data.data.signature,
    //         jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
    //       })
    //     }
    //   }).catch(res => {
    //   })
    //   window.wx.ready(function () {
    //     window.wx.onMenuShareTimeline({
    //       title: data['标题'],
    //       imgUrl: data['图片'],
    //       link: window.location.href,
    //       success: function () {},
    //       cancel: function () {}
    //     })
    //     window.wx.onMenuShareAppMessage({
    //       title: data['标题'],
    //       desc: data['介绍'],
    //       imgUrl: data['图片'],
    //       link: window.location.href,
    //       type: 'link',
    //       dataUrl: '',
    //       success: () => {},
    //       cancel: () => {}
    //     })
    //   })
    // }
  },
  computed: {
    ...mapState(['lang', 'isEnLang']),
    isLangEn () {
      return this.lang === 'en-US'
    }
  },
  mounted () {
    // window.onresize = function () {
    //   this.setMoblie(this.checkMobile())
    // }.bind(this)

    // console.log(this.checkMobile())

    // window.addEventListener('resize', () => {
    //   this.setMoblie(this.checkMobile())
    // })

    // console.log(this)
  },
  created () {
    this.setMoblie(this.checkMobile())

    utils.GA('create')

    document.title = 'FinTechathon | 深圳国际金融科技大赛'
  },
  watch: {
    isEnLang (val) {
      if (val) {
        document.title = 'FinTechathon 丨WeBank’s Second University Hackathon'
      } else {
        document.title = 'FinTechathon | 深圳国际金融科技大赛'
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/css/_reset.scss';
@import '~@/assets/css/_base.scss';
@import '~@/assets/css/custom.modal';
@import '~@/assets/css/custom.popup';

// 上下间距
.section {
  padding-top: $sectionGap;
  padding-bottom: $sectionGap;

  @include mobile {
    padding-top: $sectionGapMoible;
    padding-bottom: $sectionGapMoible;
  }
}

// section 背景色
// .section-settings {
//   background: $black;
//   color: #fff;
// }

.interline-shu {
  $blue: #2B70FB;
  width: 1px;
  border-radius: 1px;;
  background: linear-gradient(to bottom, transparent , $blue 5%, $blue 95%, transparent);;
}
</style>
